<template>
    <Link class="flex items-center flex-grow-0 flex-shrink-0 relative text-gray-900 hover:text-blue-500 cursor-pointer transition-colors duration-150 py-2 px-3">
        <slot />
    </Link>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    }
}
</script>
